import React from "react";
import styles from "./styles.module.scss";

export const Input = ({ value, onChange, placeholder }) => {
  return (
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={styles.root}
      placeholder={placeholder}
    />
  );
};
